import {Component, EventEmitter, Input, Output} from '@angular/core';
import {EventItem, MultiLangField} from "@model";
import {FormControl, FormGroup} from "@angular/forms";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {max_length_100} from "@utility";

@Component({
  selector: 'app-event-short-name-modal',
  templateUrl: './event-short-name-modal.component.html',
  styleUrl: './event-short-name-modal.component.scss',
  standalone: false
})
export class EventShortNameModalComponent {
  @Input() event: EventItem | undefined;
  @Input() title: string | undefined;
  @Output() onSave = new EventEmitter<MultiLangField>();

  constructor(public activeModal: NgbActiveModal) {}

  inputForm = new FormGroup({
    hr: new FormControl(),
    en: new FormControl(),
    it: new FormControl(),
    sl: new FormControl(),
    sr: new FormControl(),
    bs: new FormControl(),
  });

  ngOnInit() {
    this.inputForm.controls.hr.addValidators([max_length_100]);
    this.inputForm.controls.en.addValidators([max_length_100]);
    this.inputForm.controls.it.addValidators([max_length_100]);
    this.inputForm.controls.sl.addValidators([max_length_100]);
    this.inputForm.controls.sr.addValidators([max_length_100]);
    this.inputForm.controls.bs.addValidators([max_length_100]);
    if (this.event?.nameShort) {
      this.inputForm.patchValue(this.event.nameShort);
    }
  }

  onClose() {
    this.activeModal.dismiss();
  }

  onSaveButtonClick() {
    const shortName: MultiLangField = {
        hr: this.inputForm.value.hr,
        en: this.inputForm.value.en,
        it: this.inputForm.value.it,
        sl: this.inputForm.value.sl,
        sr: this.inputForm.value.sr,
        bs: this.inputForm.value.bs,
    };
    this.onSave.emit(shortName);
    this.activeModal.close();
  }
}
